// Keep the global enhanceNumberInput function as is (no changes needed)

// Define a wrapper function that will use your own jQuery ready handler
jQuery(document).ready(function($) {
  // Define the enhanceQuantityInputs function to use the global enhanceNumberInput
  function enhanceQuantityInputs() {
    
    // Enhance WooCommerce quantity inputs
    document.querySelectorAll(".quantity").forEach((quantityDiv) => {
      const input = quantityDiv.querySelector(".qty");
      if (input) {
        enhanceNumberInput(input);
      }
    });
  }
  
  // Run on initial page load
  enhanceQuantityInputs();
  
  // Run when cart is updated via Ajax - use the same events
  $(document.body).on('updated_cart_totals', function() {
    enhanceQuantityInputs();
  });
  
  // Also listen for these events to catch other Ajax updates
  $(document.body).on('wc_fragments_loaded wc_fragments_refreshed', function(e) {
    enhanceQuantityInputs();
  });
  
  // Add handler for updated_wc_div which is commonly used in WooCommerce
  $(document.body).on('updated_wc_div', function() {
    enhanceQuantityInputs();
  });
});